import { render } from "./CategoryPage.vue?vue&type=template&id=aceaba30&scoped=true"
import script from "./CategoryPage.vue?vue&type=script&lang=js"
export * from "./CategoryPage.vue?vue&type=script&lang=js"

import "./CategoryPage.vue?vue&type=style&index=0&id=aceaba30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aceaba30"]])

export default __exports__